<div class="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
  <span class="material-symbols-outlined text-[120px] text-white/20 mb-6">
    {{ config().icon }}
  </span>

  <h1 class="text-3xl font-semibold text-white mb-4">
    {{ customTitle() || (config().titleKey | translate) }}
  </h1>

  <p class="text-white/60 mb-8 max-w-md">
    {{ customMessage() || (config().messageKey | translate) }}
  </p>

  <k-button
    variant="primary"
    (click)="onAction()">
    {{ config().actionKey | translate }}
  </k-button>
</div>
